import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import shared from './shared'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    user: user,
    shared: shared
  },
  state: {
      ligaActiva: null,
      jugadorActivo: null,
      nombreLigaActiva: null,
      fechaActiva: null,
      jugadorDatos: [],
      fechas: []
  },
})



// WEBPACK FOOTER //
// ./src/store/index.js